// 注册模块共享数据
const store = {
  state: {
    body: {
      tel: { code: '1', phone: '' },
      email: '',
      code: '',
      password_1: '',
      password_2: '',
      invite_code: ''
    },
    mode: 'email',
    curStep: '1',
    countDown: 0, // 倒计时
    error: ''
  }
}
// 为store添加Action更新数据方法
Object.keys(store.state).map(key => {
  store[`set${firstLetterUppercase(key)}Action`] = newValue => {
    store.state[key] = newValue
  }
})
store.resetForm = () => {
  store.state.body = {
    tel: { code: '1', phone: '' },
    email: '',
    code: '',
    password_1: '',
    password_2: '',
    invite_code: ''
  }
}

function firstLetterUppercase(name) {
  const firstChart = name.charAt(0).toUpperCase()
  return name.replace(/^\w/g, firstChart)
}
export default store
